import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const TaxManagement = lazy(() => import('./TaxManagement'));
const GovernanceCenter = lazy(() => import('./GovernanceCenter'));
const ExpensePolicySettings = lazy(() => import('./ExpensePolicySettings'));
const ApprovalDefinitions = lazy(() => import('./ApprovalDefinitions'));
const WorkflowOverrideBuilder = lazy(() => import('./WorkflowOverrideBuilder'));
const RevenuePolicySettings = lazy(() => import('./RevenuePolicySettings'));
const HMRCMTD = lazy(() => import('./HMRCMTD'));
const UKStatutoryAccounts = lazy(() => import('./UKStatutoryAccounts'));
const ApprovalsWorkbench = lazy(() => import('./ApprovalsWorkbench'));
const AuditLogViewer = lazy(() => import('./AuditLogViewer'));
const AuditTrailInspector = lazy(() => import('./AuditTrailInspector'));
const ActivityLogs = lazy(() => import('./ActivityLogs'));

export const complianceRoutes = (
  <React.Fragment key="compliance">
    <Route path="/compliance/tax" element={<TaxManagement />} />
    <Route path="/compliance/governance" element={<GovernanceCenter />} />
    <Route path="/compliance/policies/expense" element={<ExpensePolicySettings />} />
    <Route path="/compliance/approvals/definitions" element={<ApprovalDefinitions />} />
    <Route path="/compliance/approvals/overrides" element={<WorkflowOverrideBuilder />} />
    <Route path="/compliance/policies/revenue" element={<RevenuePolicySettings />} />
    <Route path="/compliance/hmrc-mtd" element={<HMRCMTD />} />
    <Route path="/compliance/uk-statutory" element={<UKStatutoryAccounts />} />
    <Route path="/compliance/approvals/workbench" element={<ApprovalsWorkbench />} />
    <Route path="/compliance/audit-log" element={<AuditLogViewer />} />
    <Route path="/compliance/audit-inspector" element={<AuditTrailInspector />} />
    <Route path="/compliance/activity-logs" element={<ActivityLogs />} />
  </React.Fragment>
);
